import Hero from "../components/Hero";
import AboutUsImag1 from "../../assets/images/AboutUs1.jpg";
import SecondaryButton from "../components/buttons/SecondaryButton";
import PrimaryButton from "../components/buttons/PrimaryButton";
import AboutUs2 from "../../assets/images/AboutUs2.jpg";
import AboutUs3 from "../../assets/images/AboutUs3.jpg";
import { useNavigate } from "react-router-dom";

const AboutUsPage = () => {
  const navigate = useNavigate();
    return (
      <div>
        <Hero title="About Us" subtitle="" backgroundImage={AboutUsImag1} />
        <div className="landing-page">
          <div className="light-row">
            <div className="column">
              <div className="title-semibold primary">About the Company</div>
              <div className="divider align-left" />
              <div className="content-semibold primary">
                Merrick Platts Financial Services provides wealth management,
                mortgages and protection products. We are based in
                Leicestershire but look after clients up and down the UK.
              </div>
              <div className="content primary">
                The business was set up in 1992 by Merrick Platts after working
                6 years for a bank. We use specialists for protection, equity
                release and Long Term Care. For complex investment and pension
                advice I use the full experience of a specialist paraplanner for
                more in depth research. Our customers expect top quality advice
                and service in an easy to understand and jargon-free way.
              </div>
            </div>
            <img
              src={AboutUs2}
              className="landing-page-image"
              alt="About Us Image 2"
            />
          </div>
        </div>
        <div className="primary-container">
          <div className="column align-center">
            <div className="content">
              Merrick Platts Financial Services provides whole of market
              mortgage advice. We always strive to find a lender that will say
              yes, even when you might think the answer is no. As a whole of
              market service, Merrick Platts Financial Services can access
              thousands of products to find one that is most suitable for you.
              For all financial areas, we work with clients to fully understand
              their circumstances and find a product that best meets their
              needs.
            </div>
            <div className="content">
              We know that people’s lives aren’t simple and it can be a
              difficult and daunting decision to move home, take on their first
              mortgage, starting to save for your future and making sure you
              make the best from your retirement. We guide our clients through
              the process, removing complexity and making it as simple as
              possible. This includes referring solicitors and accountants, a
              will writing service and home insurance.
            </div>
          </div>
        </div>

        <div className="landing-page">
          <div className="light-row">
            <img
              src={AboutUs3}
              className="landing-page-image"
              alt="Landing Page 3"
            />
            <div className="column">
              <div className="title-semibold primary">
                Meet our Financial Adviser
              </div>
              <div className="divider align-left" />
              <div className="content-semibold primary">
                Merrick Platts DipPFS | Director/ Financial Adviser
              </div>
              <div className="content primary">
                Merrick Platts is an experienced financial adviser with a strong
                commitment to helping clients make clear and confident financial
                decisions. With extensive knowledge of wealth management,
                mortgages, pensions and protection planning, Merrick provides
                straightforward, practical advice tailored to each client’s
                circumstances. He takes pride in building long-term
                relationships and supporting clients through key financial
                stages of life, helping them plan for the future and protect
                what matters most.
              </div>
              <div className="hero-buttons">
                <SecondaryButton
                  text={"Contact Merrick"}
                  onClick={() => navigate("/contact-us")}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default AboutUsPage;